/* eslint-disable */
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  kargoeTagRequest: ['data'],
  kargoeTagSuccess: ['response'],
  kargoeTagFailure: null,
  kargoeSearchItemsRequest: ['data'],
  kargoeTagSearchRequest: ['data'],
  kargoeTagSearchSuccess: ['response'],
  kargoeTagSearchFailure: null
})

export const KargoeTagTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  kargoeTags: null,
  error: null,
  modified: null
})

/* ------------- Selectors ------------- */

export const KargoeTagSelectors = {
  getData: state => state.data
}

/* ------------- Reducers ------------- */

// request the data from an api
export const request = (state, { data }) =>
  state.merge({ fetching: true, data })
export const searchRequest = (state, { data }) =>
  state.merge({ fetching: true, data })
export const searchItemsRequest = (state, { data }) =>
  state.merge({ fetching: true, data })

// successful api lookup
export const success = (state, action) => {
  const { response: { data: { data }, search = ' ' } } = action
  return state.merge({ modified: Date.now( ), fetching: false, error: null, kargoeTags: data })
}
export const successSearch = (state, action) => {
  const { response: { data: { data }, search = ' ' } } = action

  return state.merge({ modified: Date.now(), fetching: false, error: null, kargoeTags: data })
}

// Something went wrong somewhere.
export const failure = state =>
  state.merge({ modified: Date.now(), fetching: false, error: true })
export const searchFailure = state =>
  state.merge({ modified: Date.now(), fetching: false, error: true })

/* ------------- Hookup Reducers To Types ------------- */

// note that top 'createActions' and bottom 'createReducer' must match, if underscores are removed and converted to lowercase

export const reducer = createReducer(INITIAL_STATE, {
  [Types.KARGOE_TAG_REQUEST]: request,
  [Types.KARGOE_TAG_SUCCESS]: success,
  [Types.KARGOE_TAG_FAILURE]: failure,
  [Types.KARGOE_SEARCH_ITEMS_REQUEST]: searchItemsRequest,
  [Types.KARGOE_TAG_SEARCH_REQUEST]: searchRequest,
  [Types.KARGOE_TAG_SEARCH_SUCCESS]: successSearch,
  [Types.KARGOE_TAG_SEARCH_FAILURE]: searchFailure
})
